{
  "appName": "AdminPanel",
  "environment": "dev",
  "baseUrls": {
    "rateloc": {
      "dev": "https://apixcug.rateloc.com/",
      "prod": "https://apic.rateloc.com/",
      "key":  "rateloc_pvt_ltd_8kwehtwu"
    },
    "atlas": {
      "dev": "https://apicug.atlastravels.co.uk/",
      "prod": "https://api.atlastravels.co.uk/"
    },
    "quantrol": {
      "dev": "https://apixcugkafka.quantrol.io/",
      "prod": "https://api.quantrol.io/"
    }
  },
  "breadCrumbs": {
    "accommodation": "accommodation",
    "allBookings": "accommodation/bookings",
    "bookingsCancel": "accommodation/bookingCancel",
    "atlasBookingsCancel": "bookingCancel",
    "onboarding": "onboarding",
    "login": "api/auth/login",
    "getOtp": "api/v1/otp/generate",
    "verifyOtp": "api/v1/expenses/verify",
    "postuser": "onboarding/posts",
    "crm": "onboarding/crm",
    "orm": "onboarding/orm",
    "alluser": "api/users/getAllUsers",
    "update": "onboarding/updatecontact/",
    "dashboard": "accommodation/dashboard",
    "getAllSupplier": "quantum/supplier/getAllSupplier",
    "addSupplier": "quantum/supplier/addSupplier",
    "updateSupplier": "quantum/supplier/updateSupplier",
    "updateApiHealth": "quantum/supplier/updateApiHealth",
    "createBooking": "accommodation/addBooking",
    "walletMoneyRequest": "wallet/addMoneyRequest",
    "getUserById": "api/users",
    "walletStatusUpdate": "wallet/updateStatus",
    "bookingHistory": "accommodation/bookingHistory",
    "getInHouseUsers": "onboarding/getInHouseUsers",
    "setPassword": "onboarding/setPassword?email=",
    "inclusiveurl": "quantrol/allInclusive",
    "beachUrl": "quantrol/beach",
    "cancelBookingApi": "bookingCancel",
    "couponUrl": "coupon",
    "updateBookingApi": "accommodation/updateBooking",
    "getBookingHistoryByAtIdApi": "accommodation/getBookingHistoryByAtId",
    "crmApi": "onboarding/getAllUsers",
    "userApi": "onboarding",
    "getInHouseUsersApi": "onboarding/getInHouseUsers",
    "modifyAllRequest": "accommodation/modifyRequest",
    "bookingApi": "accommodation/bookings",
    "supplier": "quantum/supplier/getAllSupplier",
    "expenses": "api/v1/expenses",
    "createExpense": "api/v1/expenses/createExpense",
    "tenants": "api/v1/tenants"
  }
}
